import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Checkbox } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const SimpleGeneral = (props) => {

    const { simpleProduct, setSimpleProduct } = props;

    const { api, userData, settingData, categoryOptions, vatGroupOptions,
        currencyOptions, currencyData } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);
    const mainCurrency = currencyData?.find(option => option.id === settingData.mainCurrencyId) || null;

    const { showModal, toggleModal, table, title, refreshTable, size, footer, idRow, type } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    const selectedCurrency = currencyData?.find(option => option.id === simpleProduct.currencyId) || null;




    // Generic handler for input changes
    const handleInputChange = (e) => {
        let { name, value } = e.target;
        setSimpleProduct((prev) => ({
            ...prev,
            [name]: value,
        }));
    };




    // handle select change
    const handleSelectChange = (selectedOption, name) => {
        setSimpleProduct((prev) => ({
            ...prev,
            [name]: selectedOption.value,
        }));
    };


    const onCheckChange = (e) => {
        const name = e.target.name;
        const checked = e.target.checked;
        setSimpleProduct((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };



    return (

        <div>
            <Row className="mb-3">

                <Col>
                    <Form.Label>Barcode</Form.Label>
                    <InputGroup>
                        <InputGroup.Text><IoBarcodeOutline size={25} /></InputGroup.Text>
                        <Form.Control type="text" name="barcode"
                            onChange={handleInputChange}
                            value={simpleProduct.barcode}
                        />
                    </InputGroup>
                </Col>

                <Col>
                    <Form.Label>Name<span style={{ color: 'red' }}>*</span></Form.Label>
                    <InputGroup>
                        <Form.Control type="text" name="name"
                            onChange={handleInputChange}
                            value={simpleProduct.name}
                            required
                        />
                    </InputGroup>
                </Col>
            </Row>



            <Row className="mb-3">

                <Col md={6}>
                    <Form.Label>Category<span style={{ color: 'red' }}>*</span></Form.Label>
                    <Select
                        options={categoryOptions}
                        isSearchable={true}
                        placeholder="Select"
                        onChange={(e) => handleSelectChange(e, 'categoryId')}
                        value={categoryOptions?.find(option => option.value === simpleProduct.categoryId) || []}
                        required
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    />
                </Col>


                <Col>
                    <Form.Label>Currency<span style={{ color: 'red' }}>*</span></Form.Label>
                    <Select
                        options={currencyOptions}
                        isSearchable={true}
                        placeholder="Select"
                        onChange={(e) => handleSelectChange(e, 'currencyId')}
                        value={currencyOptions?.find(option => option.value === simpleProduct.currencyId) || []}
                        required
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    />
                </Col>


                <Col>
                    <Form.Label>Price<span style={{ color: 'red' }}>*</span></Form.Label>
                    <InputGroup>
                        <InputGroup.Text>{selectedCurrency?.symbol}</InputGroup.Text>
                        <Form.Control type="number" name="price"
                            value={simpleProduct?.price}
                            onChange={handleInputChange}
                            required />
                    </InputGroup>
                </Col>


            </Row>

            <Row className="mb-3">

            </Row>


            <Row className="mb-3">




            </Row>

            <Row className="mb-3">
                {/* Details */}
                <Form.Group as={Col}>
                    <Form.Label>Description</Form.Label>
                    <Form.Control as="textarea" name="details"
                        value={simpleProduct?.details || ''}
                        onChange={handleInputChange} />
                </Form.Group>
            </Row>


            <Row className="mb-1">
                <Col>
                    <Checkbox onChange={onCheckChange} checked={simpleProduct.isActive} name="isActive">Active</Checkbox>
                </Col>
            </Row>
        </div>

    )
}


export default SimpleGeneral;